<template>
  <div v-loading="loading" class="padding-auth-contents">
    <div class="bg-white p-2">
      <button @click="resetSearch" class="rounded-full bg-blue-500 text-white font-bold px-4 py-1 mb-3">
        検索条件をリセット
      </button>
      <form @submit.prevent="handleSubmit">
        <div class="border-b border-gray-300 mb-4">
          <div class="flex items-center mb-1">
            <p class="font-bold text-black mr-2">日時</p>
            <button type="button" @click="toggleSection('date')" class="text-blue-500 text-xs">
              {{ isSectionOpen.date ? '閉じる▽' : '開く△' }}
            </button>
          </div>
          <div v-show="isSectionOpen.date" class="p-2">
            <div class="mb-4">
              <div class="flex items-center block">
                <el-date-picker
                  v-model="inputParams.implementation_date"
                  type="datetime"
                  placeholder="カウンセリング実施日"
                  style="width: 220px"
                />
                <p class="ml-2">以降</p>
              </div>
            </div>
          </div>
        </div>
        <div class="border-b border-gray-300 mb-4">
          <div class="flex items-center mb-1">
            <p class="font-bold text-black mr-2">クライアント情報</p>
            <button type="button" @click="toggleSection('client')" class="text-blue-500 text-sm">
              {{ isSectionOpen.client ? '閉じる▽' : '開く△' }}
            </button>
          </div>
          <div v-show="isSectionOpen.client" class="p-2">
            <div class="mb-4">
              <label for="client_name" class="form-label">名前</label>
              <input
                v-model="inputParams.counseling_client.nick_name"
                id="client_name"
                placeholder="イニシャル・ニックネーム"
                type="text"
                class="form-input mb-1"
                style="width: 220px"
                @keydown.enter.prevent
              />
            </div>
            <div class="mb-4">
              <label for="client_age" class="form-label">年齢</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.age"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in client_age_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.age_others"
                  id="age_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_gender" class="form-label">性別</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.gender"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in client_gender_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.gender_others"
                  id="gender_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_residence" class="form-label">居住地</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.residence"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in client_residence_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.residence_others"
                  id="residence_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_birthplace" class="form-label">出身地</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.birthplace"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in client_birthplace_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.birthplace_others"
                  id="birthplace_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_sibling" class="form-label">兄弟構成</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.sibling"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_sibling_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.sibling_others"
                  id="sibling_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_circumstance" class="form-label">生育環境</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.counseling_client.circumstance"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_circumstance_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.counseling_client.circumstance_others"
                  id="circumstance_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="circumstance_others_detail" class="form-label">詳細な生育環境</label>
              <textarea
                v-model="inputParams.counseling_client.circumstance_others_detail"
                id="circumstance_others_detail"
                placeholder="指定なし"
                class="form-input mb-1 h-20"
                @keydown.enter.prevent
              ></textarea>
            </div>
          </div>
        </div>
        <div class="border-b border-gray-300 mb-4">
          <div class="flex items-center mb-1">
            <p class="font-bold text-black mr-2">セッション内容</p>
            <button type="button" @click="toggleSection('session')" class="text-blue-500 text-sm">
              {{ isSectionOpen.session ? '閉じる▽' : '開く△' }}
            </button>
          </div>
          <div v-show="isSectionOpen.session" class="p-2">
            <div class="mb-4">
              <label for="session_format" class="form-label">対面形式</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.session_format"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_format_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.session_format_others"
                  id="session_format_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_concerns" class="form-label">クライアントの主訴</label>
              <input
                v-model="inputParams.client_concerns"
                id="client_concerns"
                placeholder="指定なし"
                type="text"
                class="form-input mb-1"
                @keydown.enter.prevent
              />
            </div>
            <div class="mb-4">
              <label class="form-label">セッションテーマ</label>
              <div>
                <el-checkbox-group v-model="selectedSessionThemes" @change="handleCheckboxChange('selectedSessionThemes', $event)">
                  <el-checkbox v-for="theme in sessionThemes" :key="theme.id" :label="theme.id">
                    {{ theme.session_theme_name }}
                  </el-checkbox>
                </el-checkbox-group>
                <input
                  v-model="inputParams.session_theme_others"
                  id="session_theme_others"
                  placeholder="指定なし"
                  type="text"
                  class="form-input mb-1"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="session_g" class="form-label">セッションのG</label>
              <input
                v-model="inputParams.session_g"
                id="session_g"
                placeholder="指定なし"
                type="text"
                class="form-input mb-1"
                @keydown.enter.prevent
              />
            </div>
            <div class="mb-4">
              <label for="session_r" class="form-label">セッションのR</label>
              <input
                v-model="inputParams.session_r"
                id="session_r"
                placeholder="指定なし"
                type="text"
                class="form-input mb-1"
                @keydown.enter.prevent
              />
            </div>
            <div class="mb-4">
              <label for="session_type" class="form-label">セッション種別</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.session_type"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_type_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.session_type_others"
                  id="session_type_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label class="form-label">扱ったノイズ</label>
              <div>
                <el-checkbox-group v-model="selectedMentalNoises" @change="handleCheckboxChange('selectedMentalNoises', $event)">
                  <el-checkbox v-for="noise in mentalNoises" :key="noise.id" :label="noise.id">
                    <span class="text-xs md:text-sm" :style="{ color: noise.theme_color }">{{ noise.mental_noise_name }}</span>
                  </el-checkbox>
                </el-checkbox-group>
                <input
                  v-model="inputParams.session_mentalnoise_others"
                  id="session_mentalnoise_others"
                  placeholder="指定なし"
                  type="text"
                  class="form-input mb-1"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="session_findings" class="form-label">セッション後の所見等</label>
              <textarea
                v-model="inputParams.session_findings"
                id="session_findings"
                placeholder="指定なし"
                class="form-input mb-1 h-20"
                @keydown.enter.prevent
              ></textarea>
            </div>
            <div class="mb-4">
              <label for="session_time" class="form-label">セッションの時間</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.session_time"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_time_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.session_time_others"
                  id="session_time_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
        </div>
        <div class="border-b border-gray-300 mb-4">
          <div class="flex items-center mb-1">
            <p class="font-bold text-black mr-2">経過</p>
            <button type="button" @click="toggleSection('progress')" class="text-blue-500 text-sm">
              {{ isSectionOpen.progress ? '閉じる▽' : '開く△' }}
            </button>
          </div>
          <div v-show="isSectionOpen.progress" class="p-2">
            <div class="mb-4">
              <label class="form-label">クライアントの現実変化</label>
              <div>
                <el-checkbox-group v-model="selectedClientChangeds" @change="handleCheckboxChange('selectedClientChangeds', $event)">
                  <el-checkbox v-for="changeds in clientChangeds" :key="changeds.id" :label="changeds.id">
                    <span>{{ changeds.client_changed_name }}</span>
                  </el-checkbox>
                </el-checkbox-group>
                <input
                  v-model="inputParams.session_changed_others"
                  id="session_changed_others"
                  placeholder="指定なし"
                  type="text"
                  class="form-input mb-1"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_age" class="form-label">継続予定</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.continue_plan"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in continue_plan_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.continue_plan_others"
                  id="continue_plan_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
        </div>
        <div class="border-b border-gray-300 mb-4">
          <div class="flex items-center mb-1">
            <p class="font-bold text-black mr-2">ビジネスについて</p>
            <button type="button" @click="toggleSection('business')" class="text-blue-500 text-sm">
              {{ isSectionOpen.business ? '閉じる▽' : '開く△' }}
            </button>
          </div>
          <div v-show="isSectionOpen.business" class="p-2">
            <div class="mb-4">
              <label for="client_age" class="form-label">クラアント集客経路</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.client_route"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in client_route_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.client_route_others"
                  id="client_route_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="client_age" class="form-label">価格（一回あたり換算）</label>
              <div class="flex flex-col md:flex-row">
                <el-select
                  v-model="inputParams.session_price"
                  placeholder="指定なし"
                  style="width: 274px"
                  class="mb-2 md:mb-0 md:mr-2"
                >
                  <el-option
                    v-for="item in session_price_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <input
                  v-model="inputParams.session_price_others"
                  id="session_price_others"
                  placeholder="その他備考"
                  type="text"
                  class="form-input mb-1 md:mb-0 md:ml-2"
                  @keydown.enter.prevent
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center my-10">
          <button type="submit" class="bg-mentalncText text-white p-2 rounded font-bold text-base md:text-xl">この条件でレポートを検索</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch, Ref } from 'vue'
import { useStore } from '@/store/index'
import { CounselingClientChangedAttributes } from '@/types/models/counseling-client-changed'
import { CounselingSessionThemeAttributes } from '@/types/models/counseling-session-theme'
import { CounselingMentalNoiseAttributes } from '@/types/models/counseling-mental-noise'
import { useI18n } from 'vue-i18n'
import { axios, ApiResponse } from '@/plugins/axios'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default defineComponent({
  components: {
  },
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const loading = ref(false)
    const router = useRouter()

    interface SessionTheme {
      id: number;
      session_theme_name: string;
    }

    interface MentalNoise {
      id: number;
      mental_noise_name: string;
      theme_color: string;
    }

    interface ClientChanged {
      id: number;
      client_changed_name: string;
    }

    const client_gender_options = [
      {
        value: '',
        label: '指定なし',
      },
      {
        value: '男性',
        label: '男性',
      },
      {
        value: '女性',
        label: '女性',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const client_age_options = [
      {
        value: '',
        label: '指定なし',
      },
      {
        value: '10代',
        label: '10代',
      },
      {
        value: '20代',
        label: '20代',
      },
      {
        value: '30代',
        label: '30代',
      },
      {
        value: '40代',
        label: '40代',
      },
      {
        value: '50代',
        label: '50代',
      },
      {
        value: '60代',
        label: '60代',
      },
      {
        value: '70代',
        label: '70代',
      },
      {
        value: '80代',
        label: '80代',
      },
      {
        value: '90代',
        label: '90代',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const client_residence_options = [
      { value: '',label: '指定なし'},
      { value: '北海道', label: '北海道' },
      { value: '青森県', label: '青森県' },
      { value: '岩手県', label: '岩手県' },
      { value: '宮城県', label: '宮城県' },
      { value: '秋田県', label: '秋田県' },
      { value: '山形県', label: '山形県' },
      { value: '福島県', label: '福島県' },
      { value: '茨城県', label: '茨城県' },
      { value: '栃木県', label: '栃木県' },
      { value: '群馬県', label: '群馬県' },
      { value: '埼玉県', label: '埼玉県' },
      { value: '千葉県', label: '千葉県' },
      { value: '東京都', label: '東京都' },
      { value: '神奈川県', label: '神奈川県' },
      { value: '新潟県', label: '新潟県' },
      { value: '富山県', label: '富山県' },
      { value: '石川県', label: '石川県' },
      { value: '福井県', label: '福井県' },
      { value: '山梨県', label: '山梨県' },
      { value: '長野県', label: '長野県' },
      { value: '岐阜県', label: '岐阜県' },
      { value: '静岡県', label: '静岡県' },
      { value: '愛知県', label: '愛知県' },
      { value: '三重県', label: '三重県' },
      { value: '滋賀県', label: '滋賀県' },
      { value: '京都府', label: '京都府' },
      { value: '大阪府', label: '大阪府' },
      { value: '兵庫県', label: '兵庫県' },
      { value: '奈良県', label: '奈良県' },
      { value: '和歌山県', label: '和歌山県' },
      { value: '鳥取県', label: '鳥取県' },
      { value: '島根県', label: '島根県' },
      { value: '岡山県', label: '岡山県' },
      { value: '広島県', label: '広島県' },
      { value: '山口県', label: '山口県' },
      { value: '徳島県', label: '徳島県' },
      { value: '香川県', label: '香川県' },
      { value: '愛媛県', label: '愛媛県' },
      { value: '高知県', label: '高知県' },
      { value: '福岡県', label: '福岡県' },
      { value: '佐賀県', label: '佐賀県' },
      { value: '長崎県', label: '長崎県' },
      { value: '熊本県', label: '熊本県' },
      { value: '大分県', label: '大分県' },
      { value: '宮崎県', label: '宮崎県' },
      { value: '鹿児島県', label: '鹿児島県' },
      { value: '沖縄県', label: '沖縄県' },
      { value: 'その他', label: 'その他' }
    ]

    const client_birthplace_options = [
      { value: '',label: '指定なし'},
      { value: '北海道', label: '北海道' },
      { value: '青森県', label: '青森県' },
      { value: '岩手県', label: '岩手県' },
      { value: '宮城県', label: '宮城県' },
      { value: '秋田県', label: '秋田県' },
      { value: '山形県', label: '山形県' },
      { value: '福島県', label: '福島県' },
      { value: '茨城県', label: '茨城県' },
      { value: '栃木県', label: '栃木県' },
      { value: '群馬県', label: '群馬県' },
      { value: '埼玉県', label: '埼玉県' },
      { value: '千葉県', label: '千葉県' },
      { value: '東京都', label: '東京都' },
      { value: '神奈川県', label: '神奈川県' },
      { value: '新潟県', label: '新潟県' },
      { value: '富山県', label: '富山県' },
      { value: '石川県', label: '石川県' },
      { value: '福井県', label: '福井県' },
      { value: '山梨県', label: '山梨県' },
      { value: '長野県', label: '長野県' },
      { value: '岐阜県', label: '岐阜県' },
      { value: '静岡県', label: '静岡県' },
      { value: '愛知県', label: '愛知県' },
      { value: '三重県', label: '三重県' },
      { value: '滋賀県', label: '滋賀県' },
      { value: '京都府', label: '京都府' },
      { value: '大阪府', label: '大阪府' },
      { value: '兵庫県', label: '兵庫県' },
      { value: '奈良県', label: '奈良県' },
      { value: '和歌山県', label: '和歌山県' },
      { value: '鳥取県', label: '鳥取県' },
      { value: '島根県', label: '島根県' },
      { value: '岡山県', label: '岡山県' },
      { value: '広島県', label: '広島県' },
      { value: '山口県', label: '山口県' },
      { value: '徳島県', label: '徳島県' },
      { value: '香川県', label: '香川県' },
      { value: '愛媛県', label: '愛媛県' },
      { value: '高知県', label: '高知県' },
      { value: '福岡県', label: '福岡県' },
      { value: '佐賀県', label: '佐賀県' },
      { value: '長崎県', label: '長崎県' },
      { value: '熊本県', label: '熊本県' },
      { value: '大分県', label: '大分県' },
      { value: '宮崎県', label: '宮崎県' },
      { value: '鹿児島県', label: '鹿児島県' },
      { value: '沖縄県', label: '沖縄県' },
      { value: 'その他', label: 'その他' }
    ]

    const session_sibling_options = [
      { value: '',label: '指定なし'},
      { value: '長子',label: '長子' },
      { value: '中間子',label: '中間子' },
      { value: '末っ子',label: '末っ子' },
      { value: '一人っ子',label: '一人っ子' },
      { value: 'その他',label: 'その他' },
    ]

    const session_circumstance_options = [
      { value: '',label: '指定なし'},
      { value: '両親',label: '両親' },
      { value: '一人親',label: '一人親' },
      { value: 'ステップファミリー',label: 'ステップファミリー' },
      { value: '祖父母同居',label: '祖父母同居' },
      { value: '施設出身',label: '施設出身' },
      { value: '養子',label: '養子' },
      { value: 'その他',label: 'その他' },
    ]

    const session_format_options = [
      { value: '',label: '指定なし',},
      {
        value: 'オンライン個人',
        label: 'オンライン個人',
      },
      {
        value: '対面個人',
        label: '対面個人',
      },
      {
        value: 'オンライングループ',
        label: 'オンライングループ',
      },
      {
        value: '対面グループ',
        label: '対面グループ',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const session_type_options = [
      { value: '',label: '指定なし',},
      {
        value: '統合',
        label: '統合',
      },
      {
        value: 'エンプティ',
        label: 'エンプティ',
      },
      {
        value: '四面分析',
        label: '四面分析',
      },
      {
        value: '傾聴のみ',
        label: '傾聴のみ',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const session_time_options = [
      { value: '',label: '指定なし',},
      {
        value: '0〜30分',
        label: '0〜30分',
      },
      {
        value: '30〜60分',
        label: '30〜60分',
      },
      {
        value: '60〜90分',
        label: '60〜90分',
      },
      {
        value: '90〜120分',
        label: '90〜120分',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const continue_plan_options = [
      { value: '',label: '指定なし',},
      {
        value: 'セッション継続',
        label: 'セッション継続',
      },
      {
        value: '継続セッション終了',
        label: '継続セッション終了',
      },
      {
        value: '単発セッション',
        label: '単発セッション',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const client_route_options = [
      { value: '',label: '指定なし',},
      {
        value: 'メンタルノイズ会員',
        label: 'メンタルノイズ会員',
      },
      {
        value: '協会サイト',
        label: '協会サイト',
      },
      {
        value: '外部SNS',
        label: '外部SNS',
      },
      {
        value: '対面営業',
        label: '対面営業',
      },
      {
        value: '紹介・口コミ',
        label: '紹介・口コミ',
      },
      {
        value: '外部コミュニティ',
        label: '外部コミュニティ',
      },
      {
        value: 'イベント',
        label: 'イベント',
      },
      {
        value: 'その他',
        label: 'その他',
      },
    ]

    const session_price_options = [
      { value: '',label: '指定なし',},
      {
        value: '0〜5000円',
        label: '0〜5000円',
      },
      {
        value: '5001〜10000円',
        label: '5001〜10000円',
      },
      {
        value: '10001〜15000円',
        label: '10001〜15000円',
      },
      {
        value: '15001〜20000円',
        label: '15001〜20000円',
      },
      {
        value: '20001〜25000円',
        label: '20001〜25000円',
      },
      {
        value: '25001〜30000円',
        label: '25001〜30000円',
      },
      {
        value: '30001円以上',
        label: '30001円以上',
      },
    ]

    const clientChangeds = computed((): CounselingClientChangedAttributes[] | undefined => store.state.counselingReport.counselingClientChangeds)
    const sessionThemes = computed((): CounselingSessionThemeAttributes[] | undefined => store.state.counselingReport.counselingSessionThemes)
    const mentalNoises = computed((): CounselingMentalNoiseAttributes[] | undefined => store.state.counselingReport.counselingMentalNoises)

    const inputParams = ref<any>({
      id: 0,
      user_id: 0,
      counseling_client_id: 0,
      is_hidden: false,
      session_format: '',
      session_format_others: '',
      client_concerns: '',
      client_concerns_others: '',
      session_g: '',
      session_r: '',
      session_type: '',
      session_type_others: '',
      session_findings: '',
      session_time: '',
      session_time_others: '',
      session_mentalnoise_others: '',
      session_theme_others: '',
      session_changed_others: '',
      continue_plan: '',
      continue_plan_others: '',
      client_route: '',
      client_route_others: '',
      session_price: '',
      session_price_others: '',
      implementation_date: '',
      created_at: '',
      updated_at: '',
      counseling_client: {
        nick_name: '',
        gender: '',
        gender_others: '',
        age: '',
        age_others: '',
        residence: '',
        residence_others: '',
        birthplace: '',
        birthplace_others: '',
        sibling: '',
        sibling_others: '',
        circumstance: '',
        circumstance_others: '',
        circumstance_others_detail: '',
      },
      counseling_mental_noises: [],
      counseling_session_themes: [],
      counseling_client_changeds: []
    })

    const selectedSessionThemes: Ref<SessionTheme[]> = ref([]);
    const selectedMentalNoises: Ref<MentalNoise[]> = ref([]);
    const selectedClientChangeds: Ref<ClientChanged[]> = ref([]);

    // Initialize with existing values if available
    selectedSessionThemes.value = inputParams.value.counseling_session_themes || [];
    selectedMentalNoises.value = inputParams.value.counseling_mental_noises || [];
    selectedClientChangeds.value = inputParams.value.counseling_client_changeds || [];

    watch(selectedSessionThemes, (newVal) => {
      inputParams.value.counseling_session_themes = newVal.map(theme => ({ id: theme.id }));
    });

    watch(selectedMentalNoises, (newVal) => {
      inputParams.value.counseling_mental_noises = newVal.map(noise => ({ id: noise.id }));
    });

    watch(selectedClientChangeds, (newVal) => {
      inputParams.value.counseling_client_changeds = newVal.map(changed => ({ id: changed.id }));
    });

    onMounted(() => {
      store.dispatch('counselingReport/fetchCounselingClientChangeds')
      store.dispatch('counselingReport/fetchCounselingSessionThemes')
      store.dispatch('counselingReport/fetchCounselingMentalNoises')
    })

    const isSectionOpen = ref({
      date: true,
      client: true,
      session: true,
      progress: true,
      business: true,
    })

    const toggleSection = (section: keyof typeof isSectionOpen.value) => {
      isSectionOpen.value[section] = !isSectionOpen.value[section]
    }

    const handleSubmit = async () => {
      loading.value=true
      const searchData = {
        ...inputParams.value,
        selectedSessionThemes: inputParams.value.counseling_session_themes.map((theme: any) => theme.id),
        selectedMentalNoises: inputParams.value.counseling_mental_noises.map((noise: any) => noise.id),
        selectedClientChangeds: inputParams.value.counseling_client_changeds.map((changed: any) => changed.id),
      };

      try {
        const response = await axios.get('/counseling-reports/search', { params: searchData });
        loading.value=false
        store.state.counselingReport.searchDialogVisible = false
        store.dispatch('counselingReport/searchCounselingReports', { data: response.data.payload });
        router.push('/counseling-reports/')
      } catch (error) {
        console.error(error);
        loading.value=false
        ElMessage({ message: 'カウンセリングレポートの作成に失敗しました。',type: 'error'})
      }
    };

    const handleCheckboxChange = (key:any, value:any) => {
      if (key === 'selectedClientChangeds') {
        inputParams.value.counseling_client_changeds = value.map((id:any) => ({ id: Number(id) }));
      } else if (key === 'selectedSessionThemes') {
        inputParams.value.counseling_session_themes = value.map((id:any) => ({ id: Number(id) }));
      } else if (key === 'selectedMentalNoises') {
        inputParams.value.counseling_mental_noises = value.map((id:any) => ({ id: Number(id) }));
      }
    }

    const resetSearch = () => {
      inputParams.value = {
        id: 0,
        user_id: 0,
        counseling_client_id: 0,
        is_hidden: false,
        session_format: '',
        session_format_others: '',
        client_concerns: '',
        client_concerns_others: '',
        session_g: '',
        session_r: '',
        session_type: '',
        session_type_others: '',
        session_findings: '',
        session_time: '',
        session_time_others: '',
        session_mentalnoise_others: '',
        session_theme_others: '',
        session_changed_others: '',
        continue_plan: '',
        continue_plan_others: '',
        client_route: '',
        client_route_others: '',
        session_price: '',
        session_price_others: '',
        implementation_date: '',
        created_at: '',
        updated_at: '',
        counseling_client: {
          nick_name: '',
          gender: '',
          gender_others: '',
          age: '',
          age_others: '',
          residence: '',
          residence_others: '',
          birthplace: '',
          birthplace_others: '',
          sibling: '',
          sibling_others: '',
          circumstance: '',
          circumstance_others: '',
          circumstance_others_detail: '',
        },
        counseling_mental_noises: [],
        counseling_session_themes: [],
        counseling_client_changeds: []
      };

      // リセット時にチェックボックスグループもリセット
      selectedSessionThemes.value = [];
      selectedMentalNoises.value = [];
      selectedClientChangeds.value = [];
    };


    return {
      clientChangeds,
      sessionThemes,
      mentalNoises,
      inputParams,
      selectedClientChangeds,
      selectedSessionThemes,
      selectedMentalNoises,
      toggleSection,
      isSectionOpen,
      t,
      client_age_options,
      client_gender_options,
      client_residence_options,
      client_birthplace_options,
      session_sibling_options,
      session_circumstance_options,
      session_format_options,
      session_type_options,
      session_time_options,
      continue_plan_options,
      client_route_options,
      session_price_options,
      handleSubmit,
      handleCheckboxChange,
      resetSearch,
      loading
    }
  }
})
</script>